---
meta:
  - title: Buenas prácticas para agentes - IUSPRO Docs
  - description: Recomendaciones simples para crear agentes claros, útiles y fáciles de mantener.
---

# Buenas prácticas

Estas reglas simples ayudan a que un agente sea más útil desde el primer día.

## 1. Empiece simple

No intente meter todo en la primera versión.

Muchas veces un buen agente tiene:

1. información del caso
2. análisis jurídico u orden de ideas
3. redacción o revisión

## 2. Pida poca información

Entre menos información pida, más fácil será usar el agente.

Pida solo lo que realmente cambia entre un asunto y otro.

## 3. Cada parte debe tener una función

No trate de hacer cinco cosas distintas a la vez.

Mejor:

- una parte para analizar
- otra para ordenar
- otra para redactar

## 4. Use nombres claros

La persona debe entender rápido:

- qué hace el agente
- qué información debe aportar
- qué resultado va a recibir

## 5. Pruebe el agente con casos reales

No lo valide solo con un ejemplo perfecto.

Pruébelo con:

- información incompleta
- hechos desordenados
- archivos reales
- casos normales de su práctica

## 6. Revise la depuración cuando algo no convenza

Si el resultado no convence, revise:

- la instrucción de esa parte
- lo que produjo la parte anterior
- si el orden del trabajo tiene sentido

## 7. No use un agente para todo

Hay trabajos que siguen siendo mejores en chat libre.

El agente es para procesos repetibles, no para cualquier conversación.

## Señales de que un agente está bien hecho

- otra persona lo puede usar sin que usted se lo explique
- produce resultados parecidos en calidad entre ejecuciones
- no necesita demasiadas partes
- cuando falla, usted entiende rápido por qué

## Siguiente lectura

- Repase [qué es un agente](/guias/agentes-que-es)
- Repase [cómo crear un agente](/guias/agentes-como-crear)
